import toast from 'react-hot-toast';
import translateError from '../translateError';
import { translate } from '../helpers';


export default (error: any) => {
  if(error.data.message) {
    if(error.data.message === "error.validation") {
      for (let i = 0; i < error.data.fieldErrors.length; i++) {
        const element = error.data.fieldErrors[i];
        toast.error(`فیلد ${translate(element.field)} اشتباه وارد شده است.`, {
          position: 'top-left',
          duration: 5000,
        });
      }
    }else {
      toast.error(translateError(error.data.message), {
        position: 'top-left',
        duration: 5000,
      });
    }
  }else {
    toast.error(`Bad request`, {
      position: 'top-left',
      duration: 5000,
    });
  }
}